import { render, staticRenderFns } from "./wxbatchoverview.vue?vue&type=template&id=70d17181&scoped=true&"
import script from "./wxbatchoverview.vue?vue&type=script&lang=js&"
export * from "./wxbatchoverview.vue?vue&type=script&lang=js&"
import style0 from "./wxbatchoverview.vue?vue&type=style&index=0&id=70d17181&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d17181",
  null
  
)

export default component.exports